import { APP_BACKEND_API_URL, SUCCESS_STATUS, ERROR_STATUS, UNAUTHENTICATE_STATUS, UNAUTHORIZE_STATUS } from '../constants/Config';
import axios from "axios";
import moment from 'moment';
import {AES, enc} from 'crypto-js';
import { Buffer } from "buffer";
import { toast } from 'react-toastify';

class ApiService {
    constructor() {
        this.token = this.getToken() || null;
    }

    getToken = () => {
        if(localStorage.getItem('_token')){
            let HEXA_KEY = process.env.REACT_APP_TOKEN_KEY || "";
            let originalKey  =Buffer.from(HEXA_KEY.slice(5, HEXA_KEY.length - 10), 'base64').toString('ascii')
            let testData =  AES.decrypt(localStorage.getItem('_token'), originalKey)
            return testData.toString(enc.Utf8)
        }
        return null
    }

    fetchData = async (url) => {
        try {
            const response = await fetch(`${APP_BACKEND_API_URL}${url}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': this.getToken(),
                },
                credentials: 'include'
            });
            if(response.status ===403){
                this.clearStorageTokenExpiry()
            }
            const result = await response.json();
            if (result.status === SUCCESS_STATUS) {
                return {
                    status: SUCCESS_STATUS,
                    data: result.data,
                    error: false
                };
            } else {
                if (result.status === UNAUTHENTICATE_STATUS) {
                    this.clearStorageTokenExpiry()
                    return {
                        status: UNAUTHENTICATE_STATUS,
                        error: true,
                        msg: result.message
                    };
                }
                return {
                    status: ERROR_STATUS,
                    error: true,
                    msg: result.message
                };
            }
        } catch (error) {
            
            console.log(error, 'catch')
            return {
                status: ERROR_STATUS,
                error: true,
                msg: 'some thing is wrong'
            }
        }
    }
    getCaptchaImage = async (url) => {
        try {
            const response = await fetch(`${APP_BACKEND_API_URL}${url}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include'
            });

            const result = await response.json();

            if (result.status === SUCCESS_STATUS) {
                return {
                    status: SUCCESS_STATUS,
                    data: result.data, // contains base64 captcha string
                    error: false
                };
            } else {
                return {
                    status: ERROR_STATUS,
                    error: true,
                    msg: result.message,
                    details: result.details
                };
            }
        } catch (error) {
            return {
                status: ERROR_STATUS,
                error: true,
                msg: 'networkError'
            };
        }
    }

    unAuthPostData = async (url, data) => {
        try {
            const response = await fetch(`${APP_BACKEND_API_URL}${url}`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();
            if (result.status === SUCCESS_STATUS) {
                return {
                    status: SUCCESS_STATUS,
                    data: result.data,
                    error: false
                };
            } else {
                if(response.status === 401){
                    return {
                        status: UNAUTHORIZE_STATUS,
                        error: true,
                        msg: result.message,
                        details: result.details
                    };
                }
                if (result.status === UNAUTHENTICATE_STATUS) {
                    return {
                        status: UNAUTHENTICATE_STATUS,
                        error: true,
                        msg: result.message,
                        details: result.details
                    };
                } 
                return {
                    status: ERROR_STATUS,
                    error: true,
                    msg: result.message,
                    details: result.details
                };
            }
        } catch (error) {
            return {
                status: ERROR_STATUS,
                error: true,
                msg: 'networkError'
            }
        }
    }

    postData = async (url, data) => {
        try {
            const response = await fetch(`${APP_BACKEND_API_URL}${url}`, {
                method: 'POST',
                headers: new Headers({
                    'Authorization': this.getToken(),
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(data)
            });
            if(response.status ===403){
                this.clearStorageTokenExpiry()
            }

            const result = await response.json();

            if (result.status === SUCCESS_STATUS) {
                return {
                    status: SUCCESS_STATUS,
                    data: result.data,
                    message:result.message?result.message:'',
                    totalCount: result.totalCount ? result.totalCount : null,
                    error: false
                };
            } else if (result.data && result.data.length > 0) {
                return {
                    status: SUCCESS_STATUS,
                    data: result.data,
                    error: false
                };
            } else {
                if (result.status === UNAUTHENTICATE_STATUS) {
                    this.clearStorageTokenExpiry()
                    return {
                        status: UNAUTHENTICATE_STATUS,
                        error: true,
                        msg: result.message,
                        details : result.details ? result.details  : result.message
                    };
                }
                return {
                    status: ERROR_STATUS,
                    error: true,
                    msg: result.message ?( ((response.status ===422 && result.message ==='Unprocessable entity!') || response.status ===401 )? result.details : result.message) : 'Something went wrong!',
                    details : result.details ? result.details  : result.message
                };
            }
        } catch (error) {
            console.log(error, 'error')
            return {
                status: ERROR_STATUS,
                error: true,
                msg: error,
                details : error.details ? error.details  : error.message
            }
        }
    }

    postDataForFile = async (url, filedata) => {
        try {
            const response = await fetch(`${APP_BACKEND_API_URL}${url}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'multipart/form-data',
                    'Authorization': this.getToken()
                }),
                body: filedata
            });
            if(response.status ===403){
                this.clearStorageTokenExpiry()
            }
            const result = await response.json();
            if (result.status === SUCCESS_STATUS) {
                return {
                    status: SUCCESS_STATUS,
                    data: result.data,
                    extra: result.extra ? result.extra : null,
                    error: false
                };
            } else {
                if (result.status === UNAUTHENTICATE_STATUS) {
                    this.clearStorageTokenExpiry()
                    return {
                        status: UNAUTHENTICATE_STATUS,
                        error: true,
                        msg: result.message
                    };
                }
                return {
                    status: ERROR_STATUS,
                    error: true,
                    msg: result.message ? result.message : 'Some thing went wrong!'
                };
            }
        } catch (error) {
            return {
                status: ERROR_STATUS,
                error: true,
                msg: error
            }
        }
    }

    postDataWithAxoisDownload = async (url, data) => {
        // Extract and format the date range based on form inputs
        const { fromDate, toDate } = this.getDateRangeFromForm(data.fromDate, data.toDate, data.financialYears, data.quarters);
    
        // Update data object with formatted dates
        data.fromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
        data.toDate = toDate ? moment(toDate).format('YYYY-MM-DD') : '';
    
        try {
            // Send POST request with the data
            const response = await axios({
                url: `${APP_BACKEND_API_URL}${url}`, // API endpoint
                method: 'POST',
                headers: {
                    'Authorization': this.getToken(), // Auth token
                    'Content-Type': 'application/json'
                },
                data: data,
                responseType: 'blob',
            });
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    };
    

    postDataDocsPedia = async (url, data) => {
        try {
            const response = await axios({
                url: `${APP_BACKEND_API_URL}${url}`, //url
                method: 'POST',
                headers: {
                    'Authorization': this.getToken(),
                    'Content-Type': 'application/json'
                },
                data: data,
                //responseType: 'arraybuffer'
                responseType: 'blob'
                //responseType: 'json',
            });
            return response;
        } catch (error) {
            return error

        }
    }

    postFileWithAxois = async (url, data) => {
        try {
            const response = await axios({
                url: `${APP_BACKEND_API_URL}${url}`, //url
                method: 'POST',
                headers: {
                    'Authorization': this.getToken(),
                    'Content-Type': 'multipart/form-data'
                },
                data: data,
                //responseType: 'blob'
                // responseType: 'arraybuffer', // important
            });
            return response;
        } catch (error) {
            return error
        }
    }

    postFileWithAxoisBlob = async (url, data) => {
        try {
            const response = await axios({
                url: `${APP_BACKEND_API_URL}${url}`, //url
                method: 'POST',
                headers: {
                    'Authorization': this.getToken(),
                    'Content-Type': 'multipart/form-data'
                },
                data: data,
                responseType: 'blob'
                // responseType: 'arraybuffer', // important
            });
            return response;
        } catch (error) {
            return error
        }
    }

    clearStorageTokenExpiry = () => {
        localStorage.removeItem('_token');
        localStorage.clear();
        window.location.reload();
    }

    numberFormatter = (num) => {
        if (num > 0) {
            if (num >= 10000000) {
                return (num / 10000000).toFixed(1).replace(/\.0$/, '') + 'Cr';
            }
            if (num >= 100000) {
                return (num / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
            }
            if (num >= 1000) {
                return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
            }
            return num;
        } else {
            return 0
        }
    }

    numberFormatterFull = (num) => {
        if (num > 0) {
            if (num >= 10000000) {
                return (num / 10000000).toFixed(1).replace(/\.0$/, '') + 'Cror';
            }
            if (num >= 100000) {
                return (num / 100000).toFixed(1).replace(/\.0$/, '') + 'Lakh';
            }
            if (num >= 1000) {
                return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
            }
            return num;
        } else {
            return 0
        }
    }

    addThirtyOneDays =(days)=>{
        const d = new Date(days);
        d.setDate(d.getDate() + 30);
        return d;
    }

    checkTwoDateDiff =(date1,date2)=>{
        var a = moment(date2);
        var b = moment(date1);
       return a.diff(b, 'days') // 1
    }
    checkDateForWebUsers =(fromDate, toDate, device)=>{
        const augustFirst2024 = new Date(2024, 7, 8);        
       return ((augustFirst2024 > fromDate || augustFirst2024 > toDate) && (device == "All" || device == "Web"))
    }

    checkIfFutureDate = (fromDate, toDate) => {
        const todayDate = new Date();
        return (fromDate > todayDate || toDate > todayDate); // Check if either fromDate or toDate is in the future
    }

    /**
     * Generates a date range based on user input: either a custom range (fromDate, toDate) 
     * or a financial year and quarter.
     * 
     * Validates that only one range type is selected. If both ranges or neither are selected, 
     * it shows an error. 
     * 
     * - If custom dates are provided, returns them.
     * - If a financial year and quarter are provided, calculates the range for that quarter.
     * 
     * @param {string} formFormDate - Custom start date.
     * @param {string} formToDate - Custom end date.
     * @param {string} formFinancialYear - Financial year (e.g., "21-22").
     * @param {string} formQuarter - Quarter (e.g., "Q1", "Q2").
     * 
     * @returns {Object} { fromDate, toDate } - Calculated date range.
     */
    getDateRangeFromForm = (formFormDate, formToDate, formFinancialYear, formQuarter) => {
        let fromDate = formFormDate;
        let toDate = formToDate;
        const financialYear = formFinancialYear;
        const quarter = formQuarter;
        
        // Validation to ensure only one date range is selected
        if ((fromDate && toDate) && (financialYear && quarter)) {
            toast.error("Select One Date Range 'Monthly' or 'Quarterly'.")
            return;
        }
        
        let fyFromDate, fyToDate;
    
        // If custom date range is selected
        if (fromDate && toDate) {
            return { fromDate: fromDate, toDate: toDate };
        }
        else if (financialYear && quarter) {
            const [fyStartStr, fyEndStr] = financialYear.match(/\d{2}/g); // Extracts the two-digit numbers

            const fyStart = parseInt(fyStartStr, 10) + 2000; // Convert to integer and add 2000
            const fyEnd = parseInt(fyEndStr, 10) + 2000;

            // Set the start date and end date based on the quarter
            switch (quarter.toUpperCase()) {
                case 'Q1':
                    fyFromDate = `${fyStart}-04-01`; // Start date for Q1
                    fyToDate = `${fyStart}-06-30`;   // End date for Q1
                    break;
                case 'Q2':
                    fyFromDate = `${fyStart}-07-01`; 
                    fyToDate = `${fyStart}-09-30`;   
                    break;
                case 'Q3':
                    fyFromDate = `${fyStart}-10-01`; 
                    fyToDate = `${fyStart}-12-31`;   
                    break;
                case 'Q4':
                    fyFromDate = `${fyEnd}-01-01`;   // Start date for Q4 (next year)
                    fyToDate = `${fyEnd}-03-31`;     // End date for Q4
                    break;
                default:
                    throw new Error("Invalid quarter selected. Must be Q1, Q2, Q3, or Q4.");
            }
        } else {
            toast.error("Select Date Range");
        }
        fromDate = new Date(fyFromDate);
        toDate = new Date(fyToDate);

        return { fromDate: fromDate, toDate: toDate};
    }
}

export default new ApiService()